<p-dialog-container class="popup_top_index">
    <p-dialog-header title="{{ 'Layouts.Masthead.USER_PROFILE' | translate }}"></p-dialog-header>
    <div class="p-dialog-content" [formGroup]="form" *ngIf="user$ | async as user">
        <mat-tab-group class="profile-tabs" [disableRipple]="true" [mat-stretch-tabs]="false" animationDuration="0ms">
            <mat-tab [attr.automation-id]="'profile_tab_profile'">
                <ng-template mat-tab-label>
                    <span class="p-tabs-label">{{ 'UserProfile.Security.tabProfile' | translate }}</span>
                </ng-template>
                <div class="profile-tab" pLabelAligner=".p-field-label">
                    <div class="profile-tab__card">
                        <p-field-text
                            [label]="'UserManagement.createUser.UserInfo.Email' | translate"
                            [isReadOnly]="true"
                            [formControlName]="'email'"
                        ></p-field-text>
                        <p-field-date
                            [isReadOnly]="true"
                            [label]="'UserProfile.lastLogin' | translate"
                            [formControlName]="'lastLoginTime'"
                        ></p-field-date>
                        <p-field-text
                            [label]="'UserProfile.nearestLicensExpiry' | translate"
                            [isReadOnly]="true"
                            [formControlName]="'nearestExpiryDate'"
                        ></p-field-text>
                        <div class="profile-tab__link-row">
                            <span class="p-field-label" aria-hidden="true"></span>
                            <p-link (onClick)="viewAllLicenses()">{{ 'UserProfile.seeAllLicenses' | translate }}</p-link>
                        </div>
                        <p-field-text
                            [label]="'UserManagement.createUser.UserInfo.FirstName' | translate"
                            [required]="true"
                            [formControlName]="'firstName'"
                        ></p-field-text>
                        <p-field-text
                            [label]="'UserManagement.createUser.UserInfo.LastName' | translate"
                            [required]="true"
                            [formControlName]="'lastName'"
                        ></p-field-text>
                        <p-field-single-select
                            label="{{ 'JobTitle.Label' | translate }}"
                            [formControlName]="'jobTitle'"
                            [list]="jobTitles"
                            menuCustomClasses="job-title-menu"
                        ></p-field-single-select>
                        <p-field-text
                            [label]="'UserManagement.createUser.UserInfo.SapUserName' | translate"
                            [formControlName]="'sapOwnerName'"
                        ></p-field-text>
                        <p-field-single-select
                            label="{{ 'UserProfile.language' | translate }}"
                            idField="tag"
                            [formControlName]="'language'"
                            [list]="language"
                        ></p-field-single-select>

                        <div class="profile-tab__section-title">
                            {{ 'SystemSetup.userMng.contentSetting' | translate }}
                        </div>
                        <div class="profile-tab__consent-note">
                            {{ 'SystemSetup.userMng.confirmConsent' | translate }}
                        </div>
                        <p-field-checkbox
                            [labelOnLeft]="false"
                            [formControlName]="'receivingMsg'"
                            label="{{ 'SystemSetup.userMng.receivingMsg' | translate }}"
                            *ngIf="user.isSapOwnerDisplyed"
                        ></p-field-checkbox>
                        <p-field-checkbox
                            [labelOnLeft]="false"
                            [formControlName]="'receivingEmail'"
                            label="{{ 'SystemSetup.userMng.receivingUpdate' | translate }}"
                        ></p-field-checkbox>
                    </div>
                </div>
            </mat-tab>

            <mat-tab
                *ngIf="!user.isExternalAuth"
                [attr.automation-id]="'profile_tab_security'"
            >
                <ng-template mat-tab-label>
                    <span class="p-tabs-label">{{ 'UserProfile.Security.tabSecurity' | translate }}</span>
                </ng-template>
                <p-user-security-tab
                    class="security-tab"
                    [companyId]="companyId"
                    [stagedDefault]="stagedDefault"
                    (changePassword)="onChangePassword()"
                    (makeDefault)="onMakeDefault($event)"
                    (stateChange)="onMfaStateChange($event)"
                ></p-user-security-tab>
            </mat-tab>
        </mat-tab-group>
    </div>
    <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
</p-dialog-container>
